<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <BaseForm
      ref="form"
      :action="
        () => {
          return handleSubmit(submit);
        }
      "
      v-slot="formProps"
    >
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
        Status <span v-if="formProps.isResolved" key="resolved" class="text-green-600">Updated</span
        ><span v-if="formProps.isRejected" key="rejected" class="text-red-600">Failed</span>
      </h5>

      <VSelect
        v-model="formData.status"
        :options="statusOptions"
        :clearable="false"
        :reduce="(option) => option.value"
        :disabled="!editable || formProps.isPending"
        class="vue-select w-48"
        @input="formProps.submit"
      />
    </BaseForm>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'TaskStatus',
  props: {
    editable: Boolean,
    task: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        status: this.task.status,
      },
      statusOptions: [
        { value: 'pending', label: 'Pending' },
        { value: 'pending corrections', label: 'Pending corrections' },
        { value: 'in progress', label: 'In progress' },
        { value: 'in review', label: 'In review' },
        { value: 'completed', label: 'Completed' },
      ],
    };
  },
  watch: {
    'task.status': {
      handler(newStatus) {
        this.formData.status = newStatus;
      },
    },
  },
  methods: {
    async submit() {
      try {
        await this.$store.dispatch({
          type: 'ui/tasks/update',
          taskUuid: this.task.uuid,
          formData: this.formData,
        });

        this.$emit('status-updated');
      } catch (error) {
        // should handle 244 errors
      }
    },
  },
};
</script>
